import dataTrustpilot from "common/data/trustpilot/data.json";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import Banner from "components/organisms/Banner/index.js";
import TrustpilotFeedBack from "components/organisms/TrustpilotFeedBack";
import WhyChooseUs from "components/organisms/WhyChooseUs";

import OurCoreValues from "./OurCoreValues";
import OurPartners from "./OurPartners";
import WhoWeServes from "./WhoWeServes";

/** ========== */

const Component = ({ dataJson }) => {
  return (
    <>
      <Banner
        minHeightBanner=" banner-fix-min-h-569"
        breadcrumbs={dataJson?.breadcrumbs}
        title="Your trusted partner in company formation and management"
        titleProps={{
          className: "banner-default-title mb-6 capitalize",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-6"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src="/assets/images/offshore/about-us/banner-offshore-aboutus.png"
            wrapper={{
              className: "bbc-banner-image-country xl:top-24 pb-0 ",
            }}
            className="h-full w-full"
            width={464}
            height={439}
            alt="banner-img"
          />
        }
        bgColor="bg-bbc-gradient-service"
      ></Banner>
      <section id="section-our-story" className="mt-10 lg:mt-20">
        <div className="container">
          <Title className="title-h2 mb-6 pb-0 text-center text-bbc-brand-800 lg:text-left">
            Our Story
          </Title>
          <p className="mb-6">
            BBCIncorp Limited was established in 2017 with a mission to help
            startups and SMEs to free their resources tied up to intimidating
            company administration tasks, and thus speed up the process of
            setting up and running a business, unleashing their potential power
            for growth and expansion.
          </p>
          <p className="mb-6">
            Our services are specialized in company formation, banking
            assistance, accounting &amp; auditing, legal administration and much
            more in 20 countries across the globe.
          </p>
          <p className="mb-6">
            Our proven IT strategy with the usage of technology advancement
            along with long-term sustainable relationships in the industry allow
            us to deliver services at scale with minimum costs. Wherever you
            want to initialize your business, BBCIncorp can help to accelerate
            the process in a reliable and successful manner.
          </p>
        </div>
      </section>
      <section id="section-who-we-serves">
        <WhoWeServes
          title="Who"
          subTitle="We Serve?"
          partners={dataJson?.dataWhoWeServe}
        />
      </section>
      <WhyChooseUs
        title="What Makes Us Different"
        sectionClassName="bg-bbc-gradient-2 mt-10 lg:mt-20 py-10 lg:py-20"
        data={dataJson?.dataWhyMakeUs}
      />
      <section id="section-our-core-values">
        <OurCoreValues
          title={dataJson?.dataOurCoreValues.title}
          description={dataJson?.dataOurCoreValues.description}
          data={dataJson?.dataOurCoreValues.data}
        />
      </section>
      <section id="section-say-about-bbcincorp" className="mt-10 lg:mt-20">
        <div className="container">
          <div className="m-auto lg:col-10">
            <Title className="title-h2 mb-6 pb-0 text-center text-bbc-brand-800">
              What customers say about BBCIncorp
            </Title>
            <p className="text-center">
              Our skillful secretary have helped thousands of businesses like
              yours with their corporate governance.
            </p>
            <TrustpilotFeedBack data={dataTrustpilot.feedback} />
          </div>
        </div>
      </section>
      <div className="mb-10 lg:mb-0">
        <div className="container">
          <OurPartners
            title="Our Partners"
            description="Join our expanding network of inter-industry professionals in business solutions and gain a competitive edge."
          />
        </div>
      </div>
    </>
  );
};

export default Component;
